// extracted by mini-css-extract-plugin
module.exports = {"splitter":"contentSplitter_splitter__1SfRk","icon":"contentSplitter_icon__20VmN"};